import Button from 'components/form/Button';
import Profile from 'components/dashboard/Profile';
import React from 'react';
import useSidebarStore from 'state/useSidebar';
import useUserStore from 'state/userStore';

const HeadBar = () => {
  const { setIsOpen } = useSidebarStore();
  const { user } = useUserStore();
  return (
    <div className="fixed inset-x-0 z-10 flex items-center justify-between bg-zinc-100 py-5 lg:hidden">
      <div className="flex items-center gap-x-3">
        <Button onClick={() => setIsOpen(true)}>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="h-6 w-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
              />
            </svg>
          </span>
        </Button>
        <h3 className="text-center text-xl font-bold">BLOCKCHAIN</h3>
      </div>
      {user?.type === 'investor' && <Profile />}
    </div>
  );
};

export default HeadBar;
